// Lista de magias e runas no navegador (gerada a partir do TibiaWiki e da lista do cliente).
import type { SpellDef } from '../../../shared/src/game/spells';

let p: Promise<SpellDef[]> | null = null;
let now: SpellDef[] = [];
export function loadSpells(): Promise<SpellDef[]> {
  p ??= fetch('/data/spells.json', { cache: 'no-cache' }).then((r) => r.json()).then((l: SpellDef[]) => (now = l));
  return p;
}
export const spellsNow = () => now;
export const spellByWords = (w: string) => now.find((s) => s.words === w && s.kind === 'instant');
export const runeByItem = (id: number) => now.find((s) => s.kind === 'rune' && s.item === id);

export const SPELL_ICONS = '/assets/interface/images/spells/spell-icons-32x32.png';
